import MUIDataTable from 'mui-datatables';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllAdminPendingForms, selectAllPendingForms, setPreview, setShowHistory } from '../../giftSlice';
import { Box, Chip, IconButton, Tab, Tooltip, useMediaQuery } from '@mui/material';
import { variants } from '../../../../variants/variants';
import {
  ArrowRightAltRounded,
  CheckOutlined,
  CloseOutlined,
  ManageHistoryOutlined,
  PreviewOutlined,
  RateReviewRounded,
} from '@mui/icons-material';
import { boxBackground, colors } from '../../utility/status';
import { TabContext, TabList } from '@mui/lab';
import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useChangeStatusMutation, useDeclareResultMutation, useGetAllFormsQuery } from '../../giftApiSlice';
import { Typography } from '@mui/material';
import ApproveDialog from '../common/ApproveDialog';
import { Stack } from '@mui/material';
import UserAvatar from '../../../../common/UserAvatar';
import { format } from 'date-fns';
import ViewFeedback from '../common/ViewFeedback';
import toast from 'react-hot-toast';
import SkeletonTable from '../../../RnR/AdminRnR/SkeletonTable';
import { useTheme } from '@emotion/react';
import CustomEmptyTable from '../common/CustomEmptyTable';
import CustomRow from './CustomRow';
import { toggleSwipe } from '../../../Search/searchSlice';

const AllForms = () => {
  const { isLoading } = useGetAllFormsQuery();
  const [approve] = useChangeStatusMutation();
  const [pass] = useDeclareResultMutation();
  const dispatch = useDispatch();
  const forms = useSelector(selectAllAdminPendingForms);
  const [openFailDialog, setOpenFailDialog] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [selected, setSelected] = useState(null);
  const [interview, setInterview] = useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const theme = useTheme();
  let noData = Boolean(!forms || forms?.length === 0);

  useEffect(() => {
      // Component did mount logic here
  
      return () => {
        // Cleanup logic here
        dispatch(toggleSwipe({ value: false }))
        console.log('Component unmounted');
        // e.g., clear intervals, cancel subscriptions, etc.
      };
    }, []);

  const handleOpenFeedback = (interview) => {
    setOpenFeedback(true);
    setInterview(interview);
  };
  const handleCloseFeedback = () => {
    setOpenFeedback(false);
    setInterview(null);
  };

  const handleOpenFailDialog = (id) => {
    setOpenFailDialog(true);
    setSelected(id);
  };
  const handlePassClick = async (id) => {
    try {
      let body = { result: 'Pass' };
      const data = await pass({ id, body }).unwrap();
      toast.success('GIFT application approved');
    } catch (err) {
      console.log('error in approving', err);
      console.log('Error approving GIFT application');
    }
  };
  const handleCloseFailDialog = () => {
    setOpenFailDialog(false);
  };
  const handleViewForm = (form) => {
    dispatch(
      setPreview({
        response: form.response,
        currentDesignation: form.currentDesignation,
        desiredDesignation: form.desiredDesignation,
        interview: form.interview,
      })
    );
  };
  const handleRowClick = (rowData, { dataIndex }) => {
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
    handleViewForm({
      response: forms[dataIndex].response,
      currentDesignation: forms[dataIndex].currentDesignation,
      desiredDesignation: forms[dataIndex].desiredDesignation,
      interview: { ...forms[dataIndex].interviewDetails, formDetails: forms[dataIndex] },
    });
  };

  const columns = [
    { name: '_id', options: { display: false } },
    {
      name: 'employeeDetails',
      label: isMobile ? 'Application' : 'Employee',
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const currentDesignation = tableMeta.rowData[2].split(' - ')[0];
          const desiredDesignation = tableMeta.rowData[3].split(' - ')[0];
          const row = tableMeta.rowData;
          return isMobile ? (
            <CustomRow gift={row} handleOpenFailDialog={handleOpenFailDialog} handlePassClick={handlePassClick} />
          ) : (
            <Box>
              <Typography sx={{ fontSize: variants.BODY }}>{val?.empName}</Typography>
              <Stack direction={'row'} alignItems={'center'}>
                <Typography sx={{ fontSize: variants.TINY }}>{currentDesignation}</Typography>
                <ArrowRightAltRounded />
                <Typography sx={{ fontSize: variants.TINY }}>{desiredDesignation}</Typography>
              </Stack>
            </Box>
          );
        },
      },
    },
    {
      name: 'currentDesignation',
      label: 'From',
      options: {
        display: false,
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value.split(' - ')[0];
        },
      },
    },
    {
      name: 'desiredDesignation',
      label: 'To',
      options: {
        display: false,
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value.split(' - ')[0];
        },
      },
    },
    {
      name: 'submissionDate',
      label: 'Submission',
      options: {
        filter: false,
        sort: false,
        display: !isMobile,
        customBodyRender: (value) => {
          return new Date(value).toLocaleDateString();
        },
      },
    },
    {
      name: 'interviewDetails',
      label: 'Jury details',
      options: {
        sort: false,
        display: !isMobile,

        customBodyRenderLite: (dataIndex) => {
          let value = forms[dataIndex]?.interviewDetails;
          let juryDetails = value?.juryDetails;
          let jury = value?.jury;
          let formDetails = forms[dataIndex];
          return juryDetails?.map((member, index) => {
            const interview = { formDetails, feedback: jury[index]?.feedbackForm, member };
            return (
              <Stack direction={'row'} key={index} alignItems={'center'} sx={{ mb: 1 }}>
                <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
                {jury[index]?.feedbackForm && (
                  <Tooltip title='view feedback'>
                    <IconButton onClick={() => handleOpenFeedback(interview)}>
                      <RateReviewRounded fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            );
          });
        },
      },
    },
    {
      name: 'interviewDetails',
      label: 'Interview date',
      options: {
        sort: false,
        display: !isMobile,

        customBodyRender: (value) => {
          let meetingDate = value?.juryMeetingDate || false;
          return meetingDate ? (
            <Typography sx={{ fontSize: variants.BODY }}>{format(new Date(meetingDate), 'PPpp')}</Typography>
          ) : (
            <Chip variant='outlined' label={'Meeting not scheduled'} color='error' />
          );
        },
      },
    },
    {
      name: 'result',
      label: 'Actions',
      options: {
        sort: false,
        display: !isMobile,

        customBodyRender: (_, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <Stack direction={'row'} alignItems={'center'}>
              <Tooltip title={'Pass'}>
                <IconButton sx={{ borderColor: colors.Pass, color: colors.Pass }} onClick={() => handlePassClick(id)}>
                  <CheckOutlined sx={{ color: colors.Pass }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={'Fail'}>
                <IconButton
                  sx={{ borderColor: colors.Fail, color: colors.Fail }}
                  onClick={() => handleOpenFailDialog(id)}
                >
                  <CloseOutlined sx={{ color: colors.Fail }} />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        },
      },
    },
    {
      name: 'response',
      label: 'Form',
      options: {
        filter: false,
        sort: false,
        display: !isMobile,

        customBodyRenderLite: (dataIndex) => {
          const form = forms[dataIndex];
          return (
            <IconButton
              size='small'
              onClick={() =>
                handleViewForm({
                  response: form.response,
                  currentDesignation: form.currentDesignation,
                  desiredDesignation: form.desiredDesignation,
                  interview: { ...form.interviewDetails, formDetails: form },
                })
              }
            >
              <PreviewOutlined />
            </IconButton>
          );
        },
      },
    },
  ];
  if (isLoading)
    return (
      <Grid xs={12} md={8}>
        <SkeletonTable />
      </Grid>
    );

  return (
    <Grid
      item
      md={8}
      xs={12}
      sx={{
        background: variants.boxBackground.PROFILE_CARD,
        borderRadius: variants.boxRadius.MAIN,
        overflow: 'hidden',
        [theme.breakpoints.down('lg')]: {
          p: 0,
          background: 'transparent',
          '& .MuiTableCell-footer': {
            p: 0,
            border: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          border: 1,
          background: '#fff',
          borderRadius: variants.boxRadius.MAIN,
          overflow: 'hidden',
          borderColor: 'divider',
          m: isMobile ? 0 : 1,
        }}
      >
        <MUIDataTable
          title={null}
          data={forms}
          columns={columns}
          options={{
            elevation: 0,
            selectableRows: false,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20],
            tableBodyHeight: `calc(100vh - ${isMobile ? '125px' : '145px'})`,
            viewColumns: false,
            search: false,
            searchAlwaysOpen: true,
            download: false,
            filter: false,
            print: false,
            responsive: 'standard',
            onRowClick: isMobile ? handleRowClick : () => {},
          }}
          components={{
            ...(noData && {
              TableBody: CustomEmptyTable,
            }),
          }}
        />
        <ApproveDialog
          status={'Rejected'}
          open={openFailDialog}
          handleClose={handleCloseFailDialog}
          title={'Reject GIFT application'}
          label={'Please give an appropriate reason for not selecting the candidate:'}
          selected={selected}
          textarea={true}
          reject={true}
        />
        <ViewFeedback open={openFeedback} handleClose={handleCloseFeedback} interview={interview} />
      </Box>
    </Grid>
  );
};

export default AllForms;
